import { checkboxClasses } from '@mui/material';

const styleOverrides = {
  root: {
    padding: '4px',
    margin: '-4px',
    [`&.${checkboxClasses.disabled}`]: {
      opacity: 0.4,
    },
  },
};

export default styleOverrides;
